import React, {useState} from "react";
import "./page.css"
import PopupArticle from "./components/PopupArticle";

export default function News(){
    const PopupArticles =(props)=>{
        const closeModal =()=>{
            props.setShowModal(0);
        }
        const modalContent = {
            background: "white",
            padding: "20px 15px",
            borderRadius: "15px",
          };
        
          const overlay = {
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.5)",
        
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          };
        return(
            <>
            {props.showFlag ? (
                <div id="overlay" style={overlay}>
                    <div className="modalContent" style={modalContent}>
                        <h1>{props.title}</h1>
                        <p>{props.date}</p>
                        {props.component}
                        <button onClick={closeModal}>Close</button>
                    </div>
                </div>
            ) : (
                <></>
            )}
            </>
        )
    }

    const [showModal1, setShowModal1] = useState(false); // Modalコンポーネントの表示の状態を定義する
    const [showModal2, setShowModal2] = useState(false); // Modalコンポーネントの表示の状態を定義する
    const ShowModal1=()=>{
        setShowModal1(true);
    }
    const ShowModal2=()=>{
        setShowModal2(true);
    }


    return(
        <div className="background news-background">
            <h2 className="section-title">NEWS</h2>
        <div className="news-container-div">
            <div className="App">  
            <button onClick={ShowModal2} className='news-button'>2023/07/01 第69回辛夷祭公式SNSはじめました！</button>
            <PopupArticle 
              showFlag = {showModal2} 
              setShowModal={setShowModal2} 
              title="第69回辛夷祭　公式SNSはじめました！" 
              date="2023年7月1日"
              component={<>
              <p>第69回辛夷祭の公式アカウントが、TwitterとInstagramに登場。</p>
              <p>サイト右下のリンクから、ぜひご覧ください！</p>
              </>}
              />
          </div>
          <div className="App">  
            <button onClick={ShowModal1} className='news-button'></button>
            <PopupArticle 
              showFlag = {showModal1} 
              setShowModal={setShowModal1} 
              title="辛夷祭公式サイトへようこそ！" 
              date="2023年7月1日"
              content=""
              content2=""/>
          </div>
         
        </div>
        </div>
    )

    
    
}

